export default "__VITE_ASSET__Db0zOat7__"